<template>
    <div>
        <h4>Entries</h4>
        <template v-for="entry in person.upcoming_entries">
            <h5>{{ entry.event.name }} &nbsp;&nbsp;
                <entry-status-label :status="entry.status"></entry-status-label>
                <info-labels :labels="entry.labels"></info-labels>
            </h5>
            <table class="table">
                <tbody>
                <tr v-if="entry.is_approved || entry.race_number > 0">
                    <td>Event number</td>
                    <td>
                        <race-number-edit :entry="entry"></race-number-edit>
                    </td>
                </tr>
                <tr>
                    <td>Predicted Time</td>
                    <td>{{ entry.predicted_time }}</td>
                </tr>
                <tr v-if="entry.timing_pen.id">
                    <td>Start Pen</td>
                    <td>{{ entry.timing_pen.colour }} <colour-block :colour="entry.timing_pen.colour_code"></colour-block></td>
                </tr>
                <tr>
                    <td>Entry Name</td>
                    <td>{{ entry.name }}</td>
                </tr>
                <tr>
                    <td style="min-width: 130px">Event start time</td>
                    <td>{{ entry.event.start_time }}</td>
                </tr>
                <tr>
                    <td>Entry method</td>
                    <td>{{ entry.entry_method.name }}</td>
                </tr>

                <tr>
                    <td>Charity</td>
                    <td>{{ entry.charity.name }}</td>
                </tr>
                </tbody>
            </table>
        </template>
    </div>
</template>

<script>
    import EntryStatusLabel from './EntryStatusLabel.vue'
    import RaceNumberEdit from "./RaceNumberEdit";
    import ColourBlock from '../Support/ColourBlock.vue'
    import InfoLabels from "./InfoLabels";

    export default {
        props: ['person'],

        data() {
            return {
                lodash: window._,
            };
        },

        components: {
            InfoLabels,
            RaceNumberEdit,
            EntryStatusLabel,
            ColourBlock,
        },
    }
</script>
